import {store} from "../../store";
import routeMapper from "../routeMapper";
import versionCompare from "../../mobile/versionCompare";
import appConfig from "./../../appconfig";
import * as IdpHelper from "../../helper/IdpHelper";
import {afterSuccessfulLoginHelper} from "../../libraries/utils";
import PreCheckoutGt3 from "../../components/ShopComponents/gt3/PreCheckout-gt3";
import { DeliveryMethodsEnum } from "../../domains2/libraries/DeliveryMethods";
import * as mutationTypes from "../../store/mutation-types";
import BasketPresentationGt3 from "../../components/ShopComponents/gt3/ShoppingCart/BasketPresentation-gt3.vue";
import RedirectHelper from "../../components/UtilityComponents/RedirectHelper.vue";
import BasketFullScreenGt3 from "../../components/ShopComponents/gt3/ShoppingCart/BasketFullScreen-gt3.vue";

// const CheckoutWrapper = () => import("../../components/ShopComponents/gt3/ShoppingCartWrapper-gt3.vue");
// const ChannelDiscriminator = () => import("../../components/ShopComponents/gt3/ChannelDiscriminator-gt3.vue");
const CartWizard = () => import("../../components/ShopComponents/gt3/ShoppingCartWizard-gt3");
const HomeWrapper = () => import("../../components/ShopComponents/gt3/HomeWrapper-gt3");
const ProductCatalog = () => import("../../components/ShopComponents/gt3/ProductCatalog/ProductCatalogWrapper-gt3");
const ProductCatalogDetails = () => import("../../components/ShopComponents/gt3/ProductCatalog/DetailsTemplates/ProductCatalogDetails-gt3");
const ProductCatalogDetailsSinglePage = () => import("../../components/ShopComponents/gt3/ProductCatalog/DetailsTemplates/ProductCatalogDetailsSinglePage-gt3.vue");
const ProductCatalogDetailsSinglePageSimpleItem = () => import("../../components/ShopComponents/gt3/ProductCatalog/DetailsTemplates/ProductCatalogDetailsSinglePageSimpleItem-gt3.vue");
const ProductCatalogList = () => import("../../components/ShopComponents/gt3/ProductCatalog/ProductCatalogList-gt3");
const ShopPreSelectionWrapper = () => import("../../components/ShopComponents/gt3/ShopPreSelection/ShopPreSelectionWrapper-gt3");
const Payment = () => import("../../components/ShopComponents/gt3/Payment-gt3");
const PaymentDesktop = () => import("../../components/ShopComponents/gt3/Payment-desktop-gt3");
const Checkout = () => import("../../components/ShopComponents/gt3/Checkout-gt3");
const PendingOrderWrapper = () => import("../../components/ShopComponents/gt3/PendingOrder/PendingOrderWrapper-gt3");
const GlobalShopSelection = () => import("../../components/ShopComponents/gt3/ShopSelection/GlobalShopSelection-gt3");
const ShoppingCartDeliveryMethod = () => import("../../components/ShopComponents/gt3/ShoppingCart/ShoppingCartDeliveryMethod-desktop-gt3");
const ShoppingCartUserData = () => import("../../components/ShopComponents/gt3/ShoppingCart/ShoppingCartUserData-gt3");
const ShoppingCartPickupTime = () => import("../../components/ShopComponents/gt3/ShoppingCart/ShoppingCartPickupTime-gt3");
const SubscribeWrapper = () => import("../../components/ShopComponents/gt3/Login/SubscribeWrapper-gt3");
const SetMembership = () => import("../../components/ShopComponents/gt3/Subscriptions/SetMembership-gt3");
const InitializeSubscription = () => import("../../components/ShopComponents/gt3/Subscriptions/InitializeSubscription-gt3");
const TableServingWithInactivityTimeout = () => import("../../components/ShopComponents/gt3/TableServingWithInactivityTimeout-gt3");
const DevSupport = () => import("../../components/ShopComponents/gt3/DevSupport/DevSupport-gt3");
const UserFeedback = () => import("../../components/ShopComponents/gt3/UserFeedback-gt3");
const DeliveryAddress = () => import("../../components/ShopComponents/gt3/ShoppingCart/AddressDeliveryWrapper-gt3");
const UserAddressWrapper = () => import("../../components/ShopComponents/gt3/ShoppingCart/UserAddressWrapper-gt3");
const FeedbackCompleted = () => import("../../components/ShopComponents/gt3/UserFeedbackCompleted-gt3");
const TradingConditions = () => import("../../components/ShopComponents/gt3/Tenants/TradingConditionsWrapper-gt3");
const SubscriptionPaymentFailed = () => import("../../components/ShopComponents/gt3/Subscriptions/SubscriptionPaymentFailed-gt3");
const AcceptSubscriptionTerms = () => import("../../components/ShopComponents/gt3/Subscriptions/AcceptSubscriptionTerms-gt3");
const AcceptSunsetPointsTerms = () => import("../../components/ShopComponents/gt3/Subscriptions/AcceptSunsetPointsTerms-gt3");
const SubscriptionPaymentDone = () => import("../../components/ShopComponents/gt3/Subscriptions/SubscriptionPaymentDone-gt3");
const CatalogPagePreview = () => import("../../components/ShopComponents/gt3/CatalogPagePreview-gt3");
const QRScannerComponent = () => import("../../components/ShopComponents/gt3/QRScanner-Kiosk-gt3");
const ShoppingCartDriveInBoothNumber = () => import("../../components/ShopComponents/gt3/ShoppingCart/ShoppingCartDriveInBoothNumber-gt3");
const NutritionalInformation = () => import("../../components/ShopComponents/defaultGlobalTemplate/NutritionalInformation.vue");
const UserReorderList = () => import("../../components/UtilityComponents/UserOrders/UserReorderList.vue");
const NotFoundComponent = () => import("../../components/GlobalSharedComponents/Shop/NotFound.vue");

const handlePickupRules = async () => {
	// fetch pick up rules if not fetched for any reason
	// example user forcefully refreshes the page
	if (!(store.getters.cachedPickupRules || []).length) {
		await store.dispatch(mutationTypes.FETCH_AND_CACHE_PICKUP_RULES, {
			forceRefresh: true
		});
	}
};

const handleProductTags = async () => {
	if (store.getters.featureToggles.productTagsFilter && !(store.getters.productTagsData || []).length) {
		await store.dispatch(mutationTypes.FETCH_PRODUCT_TAGS);
	}
};

export default {
	routes: [
		{
			path: "/",
			name: routeMapper.routeNames.Home,
			component: HomeWrapper,
			beforeEnter: async (to, from, next) => {
				if (store.getters.hasPendingOrder) {
					if (["kiosk", "desktopBrowser"].includes(appConfig.channelAlias())) {
						if (appConfig.channelAlias() === "desktopBrowser") {
							await IdpHelper.checkIfUserLoggedIn({
								route: to,
								store: store,
								idpService: store.getters.serverData.idpService,
								personData: store.getters.personData,
								afterSuccessfulLoginCallback: async () => {
									afterSuccessfulLoginHelper(store.getters.featureToggles, store);
								}
							});
						}
						next("/pending-order");
					}
					else {
						next();
					}
				} else {
					next();
				}
			}
		},
		{
			path: "/devSupport",
			name: routeMapper.routeNames.DevSupportGt3,
			component: DevSupport
		},
		{
			path: "/shop-pre-selection",
			name: "ShopPreSelectionWrapper",
			component: ShopPreSelectionWrapper
		},
		{
			path: "/shop-selection",
			name: routeMapper.routeNames.shopSelection,
			component: GlobalShopSelection,
			beforeEnter: async (to, from, next) => {
				const isObsoleteVersion = await versionCompare(store);

				if (store.getters.hasPendingOrder) {
					next("/pending-order");
				} else if (isObsoleteVersion) {
					next("/obsolete-version");
				} else {
					await store.commit("RECOMPUTE_PRODUCT_CATALOG_CACHE", true);
					next();
				}
			}
		},
		{
			path: "/delivery-method",
			name: routeMapper.routeNames.DeliveryMethod,
			component: ShoppingCartDeliveryMethod,
			beforeEnter: async (to, from, next) => {
				const isObsoleteVersion = await versionCompare(store);

				if (store.getters.hasPendingOrder) {
					next("/pending-order");
				} else if (isObsoleteVersion) {
					next("/obsolete-version");
				} else {
					next();
				}
			}
		},
		{
			path: "/category/:categoryId",
			name: routeMapper.routeNames.productCatalog,
			component: ProductCatalog,
			children: [
				{
					name: routeMapper.routeNames.productDetailsConfiguration,
					path: ":productId/configuration/:type/:productSelectionId",
					component: ProductCatalogDetails,
					props: true
				},
				{
					name: routeMapper.routeNames.productDetailsConfigurationSinglePage,
					path: ":productId/configuration/:productSelectionId",
					component: ProductCatalogDetailsSinglePage,
					props: true
				},
				{
					name: routeMapper.routeNames.productDetailsConfigurationSinglePageSimpleItem,
					path: ":productId/configuration-simple/:productSelectionId",
					component: ProductCatalogDetailsSinglePageSimpleItem,
					props: true
				},
				{
					name: routeMapper.routeNames.defaultProductCatalog,
					path: "",
					component: ProductCatalogList,
					props: true
				},
				{
					path: "/pre-checkout",
					name: "pre-checkout",
					component: PreCheckoutGt3
				},
				{
					path: "/nutritional-information/:productId",
					name: routeMapper.routeNames.nutritionalInformation,
					component: NutritionalInformation,
					props: true
				}
			],
			beforeEnter: async (to, from, next) => {
				await Promise.all([
					handlePickupRules(),
					handleProductTags()
				]);
				if (store.getters.hasPendingOrder) {
					next("/pending-order");
				} else {
					next();
				}
			}
		},
		{
			path: "/checkout",
			name: routeMapper.routeNames.checkout,
			component: (() => {
				switch(appConfig.channelAlias()) {
				case "kiosk": return Checkout;
				case "desktopBrowser": return CartWizard;
				}
			})(),
			beforeEnter: async (to, from, next) => {
				await Promise.all([
					handlePickupRules()
				]);
				next();
			}
		},
		{
			path: "/reordering-mode",
			name: routeMapper.routeNames.previousOrdersReordering,
			component: UserReorderList
		},
		{
			path: "/basket",
			name: routeMapper.routeNames.basketPresentation,
			component: BasketPresentationGt3
		},
		{
			path: "/full-basket",
			name: routeMapper.routeNames.fullBasket,
			component: BasketFullScreenGt3
		},
		{
			path: "/qr-scanner",
			name: routeMapper.routeNames.qrScanner,
			component: QRScannerComponent
		},
		{
			path: "/contact-data",
			name: routeMapper.routeNames.contactData,
			component: ShoppingCartUserData,
			beforeEnter: async (to, from, next) => {
				const isObsoleteVersion = await versionCompare(store);

				if (store.getters.hasPendingOrder) {
					next("/pending-order");
				} else if (isObsoleteVersion) {
					next("/obsolete-version");
				} else {
					next();
				}
			}
		},
		{
			path: "/pickup-time",
			name: routeMapper.routeNames.pickupTime,
			component: ShoppingCartPickupTime,
			beforeEnter: async (to, from, next) => {
				const isObsoleteVersion = await versionCompare(store);

				if (store.getters.hasPendingOrder) {
					next("/pending-order");
				} else if (isObsoleteVersion) {
					next("/obsolete-version");
				} else {
					next();
				}
			}
		},
		{
			path: "/payment/:action",
			name: routeMapper.routeNames.Payment,
			component: (() => {
				switch(appConfig.channelAlias()) {
				case "kiosk": return Payment;
				case "desktopBrowser": return PaymentDesktop;
				}
			})()
		},
		{
			path: "/pending-order",
			name: routeMapper.routeNames.PendingOrder,
			component: (() => {
				switch(appConfig.channelAlias()) {
				case "kiosk": return Checkout;
				case "desktopBrowser": return PendingOrderWrapper;
				}
			})(),
			beforeEnter: async (to, from, next) => {
				// if (store.getters.hasPendingOrder) {
				// 	if (appConfig.channelAlias() === "kiosk" || appConfig.channelAlias() === "desktopBrowser") {
				// 		next("/pending-order");
				// 	}
				// 	else {
				// 		next();
				// 	}
				// } else {
				next();
			// 	}
			}
		},
		{
			path: "/pending-order-desktop", /** TODO: find better route name */
			name: routeMapper.routeNames.PendingOrderDesktop,
			component: PendingOrderWrapper
		},
		{
			path: "/table-serving",
			name: routeMapper.routeNames.tableServing,
			component: TableServingWithInactivityTimeout
		},
		{
			path: "/subscribe/:membership",
			name: routeMapper.routeNames.SetMembership,
			component: SetMembership
		},
		{
			path: "/check-email",
			name: routeMapper.routeNames.CheckEmail,
			component: SubscribeWrapper
		},
		{
			path: "/sign-up",
			name: routeMapper.routeNames.SignUpForm,
			component: SubscribeWrapper
		},
		{
			path: "/subscription-finished",
			name: routeMapper.routeNames.SubscriptionFinished,
			component: SubscribeWrapper
		},
		{
			path: "/initialize-subscription",
			name: routeMapper.routeNames.InitializeSubscription,
			component: InitializeSubscription,
			beforeEnter: (to, from, next) => {
				if (to.query.error) {
					if (!store.getters.personData) {
						return next("/");
					}

					if (store.getters.personData.firstName) {
						return next("/sign-up");
					}

					return next("/check-email?flow=subscription");
				}
				next();
			}
		},
		{
			path: "/feedback",
			name: routeMapper.routeNames.feedback,
			component: UserFeedback
		},
		{
			path: "/delivery-address",
			name: routeMapper.routeNames.deliveryAddress,
			component: DeliveryAddress
		},
		{
			path: "/address-selection",
			name: routeMapper.routeNames.DeliveryAddressPicker,
			component: UserAddressWrapper
		},
		{
			path: "/feedback-completed",
			name: routeMapper.routeNames.feedbackCompleted,
			component: FeedbackCompleted
		},
		{
			path: "/terms-conditions",
			name: routeMapper.routeNames.TradingConditions,
			component: TradingConditions
		},
		{
			path: "/subscription-payment-failed",
			name: routeMapper.routeNames.SubscriptionPaymentFailed,
			component: SubscriptionPaymentFailed
		},
		{
			path: "/accept-subscription-terms",
			name: routeMapper.routeNames.AcceptSubscriptionTerms,
			component: AcceptSubscriptionTerms
		},
		{
			path: "/accept-sunsetpoints-terms",
			name: routeMapper.routeNames.AcceptSunsetPointsTerms,
			component: AcceptSunsetPointsTerms
		},
		{
			path: "/subscription-payment-done",
			name: routeMapper.routeNames.SubscriptionPaymentDone,
			component: SubscriptionPaymentDone
		},
		{
			path: "/subscription-plans",
			name: "subscription-plans-fallback",
			beforeEnter: async (to, from, next) => {
				next("/");
			}
		},
		{
			path: "/catalogPagePreview",
			name: routeMapper.routeNames.catalogPagePreview,
			component: CatalogPagePreview,
			beforeEnter: (_to, _from, next) => {
				store.commit("RECOMPUTE_PRODUCT_CATALOG_CACHE", true);
				next();
			}
		},
		{
			path: "/booth-number",
			name: routeMapper.routeNames.boothNumber,
			component: ShoppingCartDriveInBoothNumber,
			beforeEnter: (to, from, next) => {
				const deliveryChoice = (store.getters.tenantSpecificData || {}).deliveryChoice;
				if (deliveryChoice === DeliveryMethodsEnum.DRIVE_IN) {
					next();
				} else {
					next({ name: routeMapper.routeNames.Home });
				}
			}
		},
		{
			path: "/redirect-helper",
			name: routeMapper.routeNames.redirectHelper,
			component: RedirectHelper
		},
		{
			path: "/:xyz(.*)*", // show 404 if not route found
			name: routeMapper.routeNames.notFoundPage,
			component: NotFoundComponent
		}
	]
};
